import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/fab hub logo (tm).png";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaPinterestP,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  const goToMyOrders = () => {
    navigate("/user-profile?tab=myOrders");
  };
  return (
    <footer className="bg-[#18191a] text-white">
      {/* Top Footer Section */}
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {/* Logo + Social */}
        <div>
          <img crossOrigin="anonymous"  src={logo} alt="AavryaA Logo" className="mb-4 w-48" />
          <div className="flex space-x-9 text-lg">
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter className="hover:text-gray-400 cursor-pointer" />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF className="hover:text-gray-400 cursor-pointer" />
            </a>
            <a
              href="https://www.instagram.com/acchoosclothing?igsh=dHd2NWluOHpzaWM4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="hover:text-gray-400 cursor-pointer" />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube className="hover:text-gray-400 cursor-pointer" />
            </a>
          </div>
        </div>

        {/* Company Info */}
        <div>
          <h3 className="font-semibold mb-4">AavryaA Traders </h3>
          <ul className="space-y-2 text-sm">
            <li className="hover:text-gray-400 cursor-pointer">
              <Link to="/about-us">About Us</Link>
            </li>
            {/* <li className="hover:text-gray-400 cursor-pointer">Blogs</li> */}
            <li>
              <a
                href="https://wa.me/919944592904?text=Hi%20I%20want%20to%20get%20in%20touch%20with%20AavryaA"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-400"
              >
                Get In Touch
              </a>
            </li>
            <li
              onClick={goToMyOrders}
              className="hover:text-gray-400 cursor-pointer"
            >
              My Orders
            </li>
            <li className="hover:text-gray-400 cursor-pointer">
              <Link to="/reviews">Reviews</Link>
            </li>
            {/* <li className="hover:text-gray-400 cursor-pointer">AavryaA Foundation</li> */}
          </ul>
        </div>

        {/* More Information */}
        <div>
          <h3 className="font-semibold mb-4">MORE INFORMATION</h3>
          <ul className="space-y-2 text-sm">
            <li className="hover:text-gray-400 cursor-pointer">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li className="hover:text-gray-400 cursor-pointer">
              <Link to="/refund-policy">Refund & Return/Exchange Policy</Link>
            </li>
            <li className="hover:text-gray-400 cursor-pointer">
              <Link to="/shipping-policy">Shipping & Payment Policy</Link>
            </li>
            <li className="hover:text-gray-400 cursor-pointer">
              <Link to="/terms-conditions">Terms & Conditions</Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold mb-4">Contact Us</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="tel:+919459453535" className="hover:text-gray-400">
                📞 +91 99445 92904
              </a>
            </li>
            <li>
              <a
                href="mailto:aavryaafabhub@gmail.com"
                className="hover:text-gray-400"
              >
                ✉️ aavryaafabhub@gmail.com
              </a>
            </li>
            <li className="mt-2 font-semibold">Manufactured & Marketed By</li>
            <li>AAVRYAA TRADERS</li>
            <li>
              Address: 49, First Main Rd, Ramlinga Nagar, Woraiyur,
              Tiruchirappalli, Tamil Nadu 620017
            </li>
            <li className="font-semibold">Country Of Origin:</li>
            <li>India</li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="py-4 px-6 flex flex-col items-center gap-4 border-t border-[#D8B4FE]">
        {/* Payment Icons */}
        {/* <div className="flex space-x-3">
          <img crossOrigin="anonymous"  src="/visa.png" alt="Visa" className="h-6" />
          <img crossOrigin="anonymous"  src="/mastercard.png" alt="MasterCard" className="h-6" />
          <img crossOrigin="anonymous"  src="/amex.png" alt="Amex" className="h-6" />
          <img crossOrigin="anonymous"  src="/rupay.png" alt="Rupay" className="h-6" />
        </div> */}
        <p className="text-xs text-center text-gray-300">
          © All Rights Reserved | AavryaaFabHub {" "}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
